var _path;
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.78 33.305l-7.587-7.587a.742.742 0 00-.532-.22h-.825A12.964 12.964 0 0030 17c-.001-7.18-5.82-13-13.001-13C9.82 4 4 9.818 4 17c0 7.18 5.818 12.999 13 12.999a12.96 12.96 0 008.499-3.163v.825c0 .2.081.388.219.532l7.587 7.587a.75.75 0 001.062 0l1.413-1.413a.75.75 0 000-1.062zM17 26.999c-5.525 0-10-4.475-10-10 0-5.524 4.475-10 10-10 5.524 0 9.999 4.476 9.999 10 0 5.525-4.475 10-10 10z"
  })));
}
export default SvgSearch;